import React from 'react';

const Tamga = () => {
    return (
        <main>
            <h1>Тамгын лам</h1>
        </main>
    )
}
export default Tamga;